export enum UserPropertyEnum {
  BOOLEAN_VALUE = 'booleanValue',
  NUMBER_VALUE = 'numberValue',
  STRING_VALUE = 'stringValue',
  JSON_VALUE = 'jsonValue',
  DEFAULT_WORKSPACE = 'userDefaultWorkspace',
  AUTO_ASSIGNED_DEFAULT_WORKSPACE = 'autoAssignedDefaultWorkspace',
  PROFILE = 'profile',
  CONSIDER_FOR_WAVEFORM_EXP = 'considerForWaveformExperiment-aa-9-7-21',
}

export const userProperties = {
  [UserPropertyEnum.BOOLEAN_VALUE]: {
    defaultValue: false,
    type: Boolean,
  },
  [UserPropertyEnum.NUMBER_VALUE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.STRING_VALUE]: {
    defaultValue: '',
    type: String,
  },
  [UserPropertyEnum.JSON_VALUE]: {
    defaultValue: null,
    type: JSON,
  },
  [UserPropertyEnum.DEFAULT_WORKSPACE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.PROFILE]: {
    defaultValue: {
      v1: {
        role: '',
        location: '',
        introLoom: '',
      },
    },
    type: JSON,
  },
  [UserPropertyEnum.CONSIDER_FOR_WAVEFORM_EXP]: {
    defaultValue: false,
    type: Boolean,
  },
};

type JsonType = {
  something: string;
  somethingElse: number;
  also?: boolean;
};

type ProfileV1JsonType = {
  role?: string;
  location?: string;
  introLoom?: string;
};

type ProfileJsonType = {
  v1: ProfileV1JsonType;
};

export type UserPropertyValueType<T> = T extends UserPropertyEnum.BOOLEAN_VALUE
  ? boolean
  : T extends UserPropertyEnum.NUMBER_VALUE
  ? number
  : T extends UserPropertyEnum.STRING_VALUE
  ? string
  : T extends UserPropertyEnum.JSON_VALUE
  ? JsonType
  : T extends UserPropertyEnum.DEFAULT_WORKSPACE
  ? number
  : T extends UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE
  ? number
  : T extends UserPropertyEnum.PROFILE
  ? ProfileJsonType
  : T extends UserPropertyEnum.BOOLEAN_VALUE
  ? boolean
  : unknown;
